<template>
  <div class="pop-over">
    <div>
      <div class="description">
        {{ $t('upload_file_text') }}
      </div>

      <input class="file-upload" type="file" ref="doc" @change="readFile()"/>

      <div class="button-footer">
        <div class="navigation-buttons">
          <button class="btn btn-outline-dark back" type="submit" @click="close">
            {{ $t('back_2') }}
          </button>
        </div>

        <div class="navigation-buttons">
          <button class="btn btn-outline-dark next" type="submit" @click="continueQuiz()" :disabled="fileContent === null">
            {{ $t('continue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploadPopup',
  data() {
    return {
      file: null,
      fileContent:null

    };
  },
  methods: {
    continueQuiz() {
      this.$emit("existingQuestionnaire", this.fileContent);
    },
    close() {
      this.$emit("close");
    },
    readFile() {
      this.file = this.$refs.doc.files[0];
      const reader = new FileReader();
      if (this.file.name.includes(".txt")) {
        reader.onload = (res) => {
          this.fileContent = res.target.result;
        };
        reader.readAsText(this.file);
      } else {
        reader.onerror = (err) => console.log(err);
        reader.readAsText(this.file);
      }
    }
  }
};
</script>

<style scoped>
.pop-over {
  background-color: #ffff;
  position: fixed;
  margin: auto;
  width: 500px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  border-radius: 15px;

}

.button-footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 60px 10px 10px 0;
}

.btn {
  width: 90px;
}

.file-upload {
  width: 250px;

}

.description {
  padding: 2rem;
  font-size: 1.2rem;
}
</style>